import React, { ReactNode } from 'react'
import Link from 'next/link'

type Props = {
  href: string
  blank?: boolean
  isTextDeco?: boolean
  children: ReactNode
}

export const Linker: React.FC<Props> = ({ href, children, blank, isTextDeco }) => {
  return (
    <Link href={href} passHref target={blank ? '_blank' : '_self'} style={{ textDecoration: isTextDeco ? 'underline' : 'none' }}>
      {children}
    </Link>
  )
}
